import { render, staticRenderFns } from "./CompleteDealButton.vue?vue&type=template&id=39c1b633&lang=pug&"
import script from "./CompleteDealButton.vue?vue&type=script&lang=ts&"
export * from "./CompleteDealButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports